import { Component, inject } from '@angular/core';
import { SharedService } from '@shared/services/shared.service';
import { InHomeCareLicenseService } from 'app/services/license/in-home-care/in-home-care-license.service';

@Component({
  selector: 'in-home-care-reports',
  templateUrl: './in-home-care-reports.component.html',
  styleUrls: ['./in-home-care-reports.component.scss']
})
export class InHomeCareReportsComponent {
  public selectedReport: string = '';

  public sharedService = inject(SharedService);
  public licenseService = inject(InHomeCareLicenseService);

  downloadDocument(): void {
    this.licenseService.downloadReport(this.selectedReport).subscribe({
      next: response => this.saveFile(this.selectedReport, response),
      error: e => {
        this.sharedService.toastr.error("Could not download document");
        console.log('Error downloading document', e);
      },
      complete: () => this.selectedReport = ''
    });
  }

  saveFile(fileName: string, blob: Blob) {
    let file = URL.createObjectURL(blob);
    var fileDownload = document.createElement("a");
    fileDownload.href = file;
    fileDownload.download = fileName + '-report.csv';
    fileDownload.click();
  }
}
